import { useEffect, useState } from "react"
import gptModelArray from "../../utils/gpt-models"
import Button from "../button/Button"
import { IGptModel } from "../../types/gpt-interface"
import axiosInstance from "../../utils/axios-instance"
import { toast } from "react-toastify"
import { ParseErrors } from "../../utils/parse-errors"


const GptSettings = () => {
    const [gptData, setGptData] = useState<IGptModel>({})
    const [values, setValues] = useState<Record<string, any>>()
    const [loading, setLoading] = useState<boolean>(false)


    const HandleOnChange = (e) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const UpdateGptData = async () => {
        setLoading(true)
        try {
            await axiosInstance.post('/gpt/create', values)
            toast.success("GPT updated successfully")
            setLoading(false)
        } catch (err) {
            console.log(err)
            toast.error(ParseErrors(err))
            setLoading(false)
        }
    }

    useEffect(() => {
        const getGptModel = async () => {
            try {
                const res = await axiosInstance.get('/gpt')
                setGptData(res.data.data)
            } catch (err) {
                console.log(err)
            }
        }

        getGptModel()
    }, [])

    const inputClass = "w-full h-[48px] border border-gray-200 rounded-xl mt-2 px-4 text-[14.5px] bg-white outline-none";
    const labelClass = "block text-[13px] font-medium text-lightBlack";

    return (
        <div className="w-full pb-12 pt-12">
            <div className="w-[92%] md:w-[60%] lg:w-[50%] mx-auto bg-white border border-gray-100 rounded-3xl p-8 lg:p-10 shadow-soft">
                <h2 className="font-display text-2xl text-lightBlack font-semibold tracking-tight">AI Settings</h2>
                <p className="text-sm text-gray-500 mt-1 mb-6">Configure model, prompt and token limits.</p>

                <div className="w-full mt-2 space-y-5">
                    <div className="w-full">
                        <label className={labelClass}>API Key</label>
                        <input type="text" onChange={HandleOnChange} name="apiKey" defaultValue={gptData.apiKey} className={inputClass} placeholder="sk-..." />
                    </div>
                    <div className="w-full">
                        <label className={labelClass}>GPT Model</label>
                        <select name="model" onChange={HandleOnChange} className={inputClass}>
                            {gptModelArray.map((item) => {
                                return <option value={item} selected={gptData.model === item} key={item}>{item}</option>
                            })}
                        </select>
                    </div>
                    <div className="w-full">
                        <label className={labelClass}>Max Tokens</label>
                        <input type="number" onChange={HandleOnChange} defaultValue={gptData.maxTokens} name="maxTokens" className={inputClass} placeholder="2048" />
                    </div>
                    <div className="w-full">
                        <label className={labelClass}>Prompt</label>
                        <textarea name="prompt" onChange={HandleOnChange} defaultValue={gptData.prompt} className={`${inputClass} !h-[140px] py-3 resize-none`} placeholder="System prompt..." />
                    </div>
                    <div className="pt-2">
                        <Button disabled={!values || loading} isLoading={loading} onClick={UpdateGptData}>Save</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GptSettings
